
    import Vue from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import TabOne from './tabsClient/tab-oneClient.vue';
    import TabTwo from './tabsClient/tab-twoClient.vue';
    import { tabValidation, toViewModel } from '@/apps/shared/utils/NF';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    export default Vue.extend({
        components: {
            TabOne,
            TabTwo,
            WhatsApp,
            XBreadcrumb
        },
        busEvents: {
            enablePrevButton() {
                this.$refs.wizard?.enableButton("prev");
            },
            disablePrevButton() {
                this.$refs.wizard?.disableButton("prev");
            },
            enableNextButton() {
                this.$refs.wizard?.showButton("next");
            },
            disableNextButton() {
                this.$refs.wizard?.hideButton("next");
            },
            hiddenPrevButton() {
                this.$refs.wizard?.hideButton("prev");
            },
            redirectSummary() {
                if (this.$route.path !== '/tecnologia/resumen') {
                    this.$router.push({ name: 'ElectronicDeviceSummary' }).catch(err => {
                        // Si la redirección falla por cualquier motivo, no hacer nada.
                        if (err.name !== 'NavigationDuplicated') {
                            console.error('Error en la navegación:', err);
                        }
                    });
                }
            },
            redirectPlan() {
                if (this.$route.path !== '/tecnologia/elegiPlan') {
                    this.$router.push({ name: 'electronic-equipment-plans-view' }).catch(err => {
                        // Si la redirección falla por cualquier motivo, no hacer nada.
                        if (err.name !== 'NavigationDuplicated') {
                            console.error('Error en la navegación:', err);
                        }
                    });
                }
            }
        },
        name: 'ElectronicDeviceClientData',
        data() {
            return {
                referente: null,
                medium: null,
                rate: null,
                precioSinDescuento: null,
                capital: null,
                cover: null,
                stepOneData: null,
                stepTwoData: null,
                stepThreeData: null,
                activeStep: 0,
                pas: null,
                breadcrumbItems: [
                    { text: 'Inicio', path: '/tecnologia' },
                    { text: 'Datos personales', path: 'tecnologia/datosCliente' },
                ],
                wizard: {
                    showStepName: false,
                    type: NF.Wizard.Type.PILLS,
                    mode: NF.Wizard.Mode.STEP_BY_STEP,
                    validationMode: NF.Wizard.ValidationMode.ALWAYS,
                    buttons: {
                        final: { text: 'Contratar', class: 'btn btn-default' },
                        prev: { text: 'Anterior', class: 'btn btn-secondary-outline' },
                        next: { text: 'Siguiente', class: 'btn btn-default' }
                    },
                    footer: {
                        align: NF.Wizard.Footer.Align.SPACE_BETWEEN,
                    },
                    steps: [
                        {
                            displayName: '',
                            content: '#step1',
                            viewModel: toViewModel(TabOne),
                            validate: (config, direction) => tabValidation(config, direction),
                            onEnter: function () {
                                this.Bus.$emit('updateBreadcrumb', { oldText: 'Contratar', newText: 'Datos personales' });
                                this.Bus.$emit('enablePrevButton');
                            },
                        },
                        {
                            displayName: '',
                            content: '#step2',
                            viewModel: toViewModel(TabTwo),
                            validate: (config, direction) => tabValidation(config, direction),
                            onEnter: function () {
                                var referente = sessionStorage.getItem("Referente");
                                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                                var medium = sessionStorage.getItem("Medium");
                                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

                                this.Bus.$emit('updateBreadcrumb', { oldText: 'Datos personales', newText: 'Contratar' });
                                this.Bus.$emit('enablePrevButton');

                                const eventData = {
                                    'pas': this.pas,
                                    'email': JSON.parse(sessionStorage.getItem("stepOneData")).email,
                                    'product': 'tecnologia',
                                    'event': 'cotizador-tecnologia-datos-equipo',
                                    'referente': this.referente,
                                    'medio': this.medium
                                };

                                window.globalThis.dataLayer.push(eventData);

                                const customWindow = window as typeof window & {
                                    _qsie?: Array<typeof eventData>;
                                };

                                customWindow._qsie ??= [];
                                customWindow._qsie.push(eventData);
                            },
                        },
                    ],
                },
            };
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Tecnología';
                const actualPath = '/tecnologia';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                    const title = this.$store.getters.getWebSaleData?.pageCustomization?.navbar?.title ?? '';
                    this.pas = title === defaultTitle ? null : title;
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultElectronicDeviceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            showFileError(errorMessage) {
                NF.Notification.show({
                    type: NF.Notification.Type.ERROR,
                    title: 'Error',
                    content: errorMessage,
                    position: NF.Notification.Positions.TOP_RIGHT,
                    clickClose: true,
                    autoHideDelay: 0
                })
            },
            open: function () {
                this.$refs.modal.open();
            },
            close: function () {
                this.$refs.modal.close();
            },
            getFilePath() {
                this.close();
                const rutaAlternativa = sessionStorage.getItem("rutaAlternativa");
                if (rutaAlternativa) {
                    this.$router.push(rutaAlternativa);
                }
                else {
                    this.$router.push({ name: 'electronic-equipment-tab-One' });
                }
            },
            async getElectronicEquipmentDiscountRange() {
                var planDataSelected = sessionStorage.getItem("PlanSelected")
                if (planDataSelected != null) {
                    this.DataPlan = JSON.parse(planDataSelected);

                    const eventData = {
                        'pas': this.pas,
                        'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                        'product': 'tecnologia',
                        'event': 'cotizador-tecnologia-plan',
                        'plan': this.DataPlan.planDescription,
                        'referente': this.referente,
                        'medio': this.medium
                    };

                    window.globalThis.dataLayer.push(eventData);

                    const customWindow = window as typeof window & {
                        _qsie?: Array<typeof eventData>;
                    };

                    customWindow._qsie ??= [];
                    customWindow._qsie.push(eventData);

                    this.planDescription = this.DataPlan.planDescription;
                    this.primerCuota = this.DataPlan.premioMensual;
                    this.capital = this.DataPlan.capital;
                    this.precioSinDescuento = this.DataPlan.premiumWithoutDiscount;
                    NF.UI.Page.block();
                    await DiscountRangeService.getElectronicEquipmentDiscountRange().then((response) => {
                        if (response.length > 0) {
                            this.responseDiscountRange = response;
                            this.rate = this.responseDiscountRange[0].discountMaxValue;
                            this.discountOff = this.responseDiscountRange[0].discountMaxValue;
                        }
                    }).finally(() => {
                        NF.UI.Page.unblock();
                    });
                }
            },
            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                this.Bus.$on('step-one-data', (stepData) => this.stepOneData = stepData);
                this.Bus.$on('step-two-data', (stepData) => this.stepTwoData = stepData);
                var coverData = sessionStorage.getItem("cover");
                if (coverData != null) {
                    this.cover = JSON.parse(coverData!)
                    this.cobertura = this.cover
                }
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                var medium = sessionStorage.getItem("Medium");
                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

                await this.pageCustomization();

                const parallelPromises = [
                    this.updateByProductGoogleAnalytics(),
                    this.getInitData()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                this.getElectronicEquipmentDiscountRange();

            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
